<template>
	<section class="cargos">
		<div
			class="cargos-container"
			v-if="!isSearchMode && virtualCargoList?.length && !loading.virtualCargoGetAll"
		>
			<PagesStorekeeperCard
				v-for="request in virtualCargoList"
				:key="request.id"
				:request="request"
				class="cargo-item"
				@addedComment="addedCommentHandler"
			/>
		</div>
		<div
			class="cargos-container"
			v-else-if="isSearchMode && storekeeperCargoListSearchByNumber?.length && !loading.storekeeperCargoSearchByNumber"
		>
			<PagesStorekeeperCard
				v-for="request in storekeeperCargoListSearchByNumber"
				:key="request.id"
				:request="request"
				class="cargo-item"
				@addedComment="addedCommentHandler"
			/>
		</div>
		<div
			v-else-if="
				!loading.virtualCargoGetAll ||
				(isSearchMode && storekeeperCargoListSearchByNumber?.length === 0 && !loading.storekeeperCargoSearchByNumber)
			"
			class="empty-container"
		>
			<TypographyKTypographyBody3
				color="var(--white)"
				font-type="medium"
			>
				{{ 'Результатов нет' }}
			</TypographyKTypographyBody3>
		</div>
		<UiLoaderLottie
			class="loader"
			v-else-if="loading.virtualCargoGetAll || loading.storekeeperCargoSearchByNumber"
			:circle-width="2"
			:color="'var(--loader-primary)'"
			:radius="20"
		/>
		<PagesStorekeeperInfoModal
			:currentCargo="storekeeperStore.currentCargo"
			:warehouseId="profileStore.profileInfo?.warehouseId"
			:currentCargoId="storekeeperStore.currentCargo?.id"
			v-model="isInfoModalOpen"
			v-if="isInfoModalOpen"
		/>
	</section>
</template>

<script setup lang="ts">
	import { useCargoCommentStore } from '~/store/cargoComment.store';
	import { useProfileStore } from '~/store/profile.store';
	import { useStorekeeperStore } from '~/store/storekeeper.store';
	import type { ICargoCommentAddResponse } from '~~/shared/interfaces/cargoComment';

	const storekeeperStore = useStorekeeperStore();
	const cargoCommentStore = useCargoCommentStore();
	const profileStore = useProfileStore();
	const pageReqInterval = ref<NodeJS.Timeout | null>(null);
	const isInfoModalOpen = storeToRefs(storekeeperStore).isInfoModalOpen;

	const virtualCargoList = storeToRefs(storekeeperStore).virtualCargoList;
	const storekeeperCargoListSearchByNumber = storeToRefs(storekeeperStore).storekeeperCargoListSearchByNumber;
	const isSearchMode = storeToRefs(storekeeperStore).isSearchMode;
	const loading = storeToRefs(storekeeperStore).loading;

	const addedCommentHandler = async (
		data: ICargoCommentAddResponse,
		additionalData: { callbackFunction: () => void }
	) => {
		const response = await cargoCommentStore.addCargoComment(data);

		if (response?.status === 'success') {
			additionalData?.callbackFunction();
		}
	};

	const getVirtualCargo = async (isNeedLoad: boolean = false) => {
		await storekeeperStore.virtualCargoGetAll(isNeedLoad);
	};
	getVirtualCargo(true);

	onMounted(() => {
		pageReqInterval.value = setInterval(() => {
			getVirtualCargo(false);
		}, 20000);
	});

	onUnmounted(() => {
		if (pageReqInterval.value) {
			clearInterval(pageReqInterval.value);
			pageReqInterval.value = null;
		}
	});
</script>

<style scoped lang="scss">
	.cargos {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;

		.cargos-container {
			display: flex;
			flex-direction: column;
			margin-top: 20px;

			.cargo-item {
				margin-bottom: 14px;

				&:last-child {
					margin-bottom: 0px;
				}
			}
		}

		.loader {
			margin: auto;
		}

		.empty-container {
			margin: auto;
		}
	}
</style>
